import React from "react";
import { observer } from "mobx-react";

import SearchStore from "@state/stores/offer/search/SearchStore";

import { SuggestedSearchListItemType } from "@data-types/suggested-search/SuggestedSearchListItemType";

import { SuggestedListEvent } from "./SuggestedListEvent";
import { SuggestedListTournament } from "./SuggestedListTournament";
import { ErrorMessage } from "@components/inputs/shared";
import { SuggestedListFreeSearchItem } from "./HeaderFreeSearchListItem";

export const HeaderSuggestedSearchList = observer(
	function HeaderSuggestedSearchList(props: { searchStore: SearchStore }) {
		return (
			<ul className="popup--search__list">
				<ErrorMessage
					name={"search"}
					customErrorClassName={
						"popup--search__term popup--search__term--error message--validation field-validation-error"
					}
				/>

				<SuggestedListFreeSearchItem />

				{props.searchStore.filteredSearchList?.map((item) => {
					if (item.type === SuggestedSearchListItemType.Event) {
						return (
							<SuggestedListEvent
								key={item.eventId}
								item={item}
							/>
						);
					}

					return (
						<SuggestedListTournament
							key={item.tournamentId}
							item={item}
						/>
					);
				})}
			</ul>
		);
	}
);
